module.exports = __webpack_public_path__ + "img/n-home.6f124e31.svg";